export default "__VITE_ASSET__CYDOyq3V__"